// extracted by mini-css-extract-plugin
export var button = "_ge-2";
export var card = "_ge-0";
export var closeButtonContainer = "_ge-3";
export var iconContainer = "_ge-1";